// extracted by mini-css-extract-plugin
module.exports = {"deliveryHome__form":"styles_deliveryHome__form__3N_YW","deliveryHome__area":"styles_deliveryHome__area__2Q5f0","deliveryHome__submit":"styles_deliveryHome__submit__2Jaev"};